import { render, staticRenderFns } from "./ProimScreen.vue?vue&type=template&id=d4615ea8"
import script from "./ProimScreen.vue?vue&type=script&lang=js"
export * from "./ProimScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports